import { Check, ChevronDown, Plus, Store } from "lucide-react";
import type { MeResponse } from "../../shared/api-types";
import { PopMenu } from "../components/kit";
import { switchRestaurant } from "./currentRestaurant";

// The restaurant switcher (owner 2026-11-04; „trebuie să fie mai vizibil de atât”): a restaurant card at the top
// of the sidebar and a bordered button in the top bar (the only one on phones). Both open the account's
// restaurants and „Adaugă un restaurant”. In support mode only the one restaurant is shown, without adding.

export function RestaurantSwitcher({
  me,
  current,
  variant = "bar",
}: {
  me: MeResponse;
  current: string;
  variant?: "bar" | "card";
}) {
  const here = me.memberships.find((m) => m.restaurant.id === current)?.restaurant;
  const name = here?.name ?? "";
  if (me.support) return variant === "bar" ? <p className="topbar-title">{name}</p> : null;
  const others = me.memberships.filter((m) => m.restaurant.id !== current);
  const count = me.memberships.length;
  return (
    <div className={`switcher switcher-${variant}`}>
      <PopMenu
        label={`Restaurant: ${name}. Schimbă sau adaugă un restaurant`}
        triggerClass="switcher-trigger"
        trigger={
          variant === "card" ? (
            <>
              <Store size={20} strokeWidth={1.75} aria-hidden="true" />
              <span className="switcher-text">
                <span className="switcher-name">{name}</span>
                <span className="switcher-hint">
                  {count > 1 ? `${count} restaurante · schimbă sau adaugă` : "Adaugă un restaurant"}
                </span>
              </span>
              <ChevronDown size={18} strokeWidth={1.75} aria-hidden="true" />
            </>
          ) : (
            <>
              <Store size={18} strokeWidth={1.75} aria-hidden="true" />
              <span className="switcher-name">{name}</span>
              <ChevronDown size={18} strokeWidth={1.75} aria-hidden="true" />
            </>
          )
        }
        header={
          <div className="pop-head">
            <span style={{ fontWeight: 600, display: "flex", alignItems: "center", gap: 6 }}>
              <Check size={16} aria-hidden="true" />
              {name}
            </span>
            <span className="caption muted" style={{ fontWeight: 400 }}>
              {count === 1 ? "Singurul restaurant al contului" : "Restaurantul deschis acum"}
            </span>
          </div>
        }
        items={[
          ...others.map((m) => ({
            label: m.restaurant.name,
            icon: Store,
            onSelect: () => switchRestaurant(m.restaurant.id),
          })),
          {
            label: "Adaugă un restaurant",
            icon: Plus,
            onSelect: () => window.location.assign("/app/restaurant-nou"),
          },
        ]}
      />
    </div>
  );
}
